export const GENERIC_PAGE_PAGINATION_PER_PAGE: number = 6;
export const TOPICS_PAGE_PAGINATION_PER_PAGE: number = 6;
export const SEARCH_PAGINATION_PER_PAGE: number = 6;
export const TOPICS_LIST_PAGINATION_PER_PAGE: number = 7;
export const FACULTY_MEMBERS_PAGINATION_PER_PAGE: number = 7;
